import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  activate(event) {
    event.preventDefault();
    event.target.click();
  }
}